// extracted by mini-css-extract-plugin
module.exports = {"Title":"videos_Title__2TCAi","Item":"videos_Item__HnVOf","Videos":"videos_Videos__c3rdi"};